import { z } from 'zod';
import { API_ERROR_CODES } from './errors.js';
export const ApiErrorSchema = z.object({
    code: z.union([z.enum(API_ERROR_CODES), z.string()]),
    message: z.string(),
    details: z.unknown().optional(),
    fields: z.record(z.string()).optional(),
});
export function EnvelopeSchema(data) {
    const okSchema = z.object({
        ok: z.literal(true),
        data,
        meta: z.record(z.unknown()).optional(),
    });
    const errSchema = z.object({
        ok: z.literal(false),
        error: ApiErrorSchema,
        traceId: z.string().optional(),
    });
    return z.union([okSchema, errSchema]);
}
export function envelopeOk(data, meta) {
    return meta === undefined ? { ok: true, data } : { ok: true, data, meta };
}
export function envelopeErr(error, traceId) {
    return traceId === undefined ? { ok: false, error } : { ok: false, error, traceId };
}
//# sourceMappingURL=envelope.js.map